<template>
    <rkm-table
        :items="localItems"
        :fields="fields.table"
        thead-class="d-none"
    >
        <template v-slot:cell(dataRegistro)="{ item }">
            <strong>Data do registro: </strong>
            <p>{{ item.dataRegistro }}</p>
        </template>

        <template v-slot:cell(dataReceita)="{ item }">
            <strong>Data da receita: </strong>
            <p>{{ item.dataReceita }}</p>
        </template>

        <template v-slot:cell(medicoSolicitante.nome)="{ item }">
            <strong>Médico solicitante: </strong>
            <p>{{ item.medicoSolicitante.nome }}</p>
        </template>

        <template v-slot:cell(isReceitaSus)="{ item }">
            <strong>Tipo da receita: </strong>
            <p>{{ item.isReceitaSus ? 'SUS' : 'Outras' }}</p>
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="edit(item)"
                color="primary"
                small
                title="Editar receita"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="destroy(item)"
                color="danger"
                small
                title="Excluir receita"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>

        <template #row-details="{ item }">
            <rkm-table
                :items="itensNaoDeletados(item)"
                :fields="fields.detail"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(actions)="{ item: medicamentoItem }">
                    <rkm-button
                        @click.stop="editItem(item, medicamentoItem)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="destroyItem(item, medicamentoItem)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </template>
    </rkm-table>
</template>


<script>
export default {
    computed: {
        fields() {
            return {
                table: [
                    { label: 'Data do registro', key: 'dataRegistro', sortable: true, },
                    { label: 'Data da receita', key: 'dataReceita', sortable: true, },
                    { label: 'Médico Solicitante', key: 'medicoSolicitante.nome', sortable: true, },
                    { label: 'Tipo da receita', key: 'isReceitaSus', sortable: true, },
                    { label: 'Ações', key: 'actions', class: 'col-min' },
                ],
                detail: [
                    { label: 'Medicamento', key: 'medicamento.descricao', sortable: true, },
                    { label: 'Quantidade', key: 'quantidade', sortable: true, },
                    { label: 'Motivo', key: 'motivo', sortable: true, },
                    { label: 'Justificativa', key: 'justificativa', sortable: true, },
                    { label: 'Ações', key: 'actions', class: 'col-min' },
                ]
            }
        },
    },
    created() {

        this.localItems = this.filteredItems()
    },
    data: () => ({
        localItems: []
    }),
    methods: {
        edit(item) {

            this.$emit('edit', item)
        },
        editItem(receita, item) {

            this.$emit('edit', receita)

            this.$nextTick(() => this.$emit('editItem', item))
        },
        destroy(item) {

            const destroy = async () => {

                const idx = this.model.medicamentoNaoAtendido.findIndex(r => r.id === item.id)

                if (Number.isInteger(item.id)) {

                    this.$set(this.model.medicamentoNaoAtendido[idx], 'deleted', true)

                } else {

                    this.model.medicamentoNaoAtendido.splice(idx, 1)
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir a receita e todos os medicamentos incluídos nela?', destroy)
        },
        destroyItem(receita, item) {

            const destroy = async () => {

                const receitaIdx = this.model.medicamentoNaoAtendido.findIndex(r => r.id === receita.id)
                const itemIdx = this.model.medicamentoNaoAtendido[receitaIdx].items.findIndex(i => i.id === item.id)

                if (Number.isInteger(item.id)) {

                    this.$set(this.model.medicamentoNaoAtendido[receitaIdx].items[itemIdx], 'deleted', true)

                } else {

                    this.model.medicamentoNaoAtendido[receitaIdx].items.splice(itemIdx, 1)
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', destroy)
        },
        itensNaoDeletados(receita) {

            return receita.items.filter(item => !item.deleted)
        },
        filteredItems() {

            const receitas = this.model.medicamentoNaoAtendido.filter(receita => !receita.deleted && this.itensNaoDeletados(receita).length > 0)

            receitas.forEach(receita => {

                receita._showDetails = true
            })

            return receitas
        }
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    },
    watch: {

        'model.medicamentoNaoAtendido': {

            deep: true,
            handler() {

                this.localItems = this.filteredItems()
            }
        }
    }
}
</script>
